  <!-- <que-mini-header [name]="questionnaireName | async" *ngIf="template==undefined"></que-mini-header> -->
  <que-preview></que-preview>

    <!-- // [isUser]="template==undefined" -->